import { render } from "./ass_entusr.vue?vue&type=template&id=072ca0ee&scoped=true"
import script from "./ass_entusr.vue?vue&type=script&lang=js"
export * from "./ass_entusr.vue?vue&type=script&lang=js"

import "./ass_entusr.vue?vue&type=style&index=0&id=072ca0ee&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/smt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072ca0ee"]])

export default __exports__